<template>
  <v-container>
    <v-form class="px-3 grey" ref="form">
      <h2>Sign In</h2>
      <v-text-field
        label="Username"
        v-model="email"
        prepend-icon="beach_access"
        required
      >
      </v-text-field>
      <v-text-field
        label="Password"
        type="password"
        v-model="password"
        prepend-icon="cake"
        required
      >
      </v-text-field>

      <v-spacer></v-spacer>
      <v-btn text class="success mx-0 mt-3" @click="login"> Sign In</v-btn>
    </v-form>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      email: "",
      roles: null,
      list: []
    };
  },
  created() {},
  methods: {
    login() {
      /*for(var x=0; x<this.list.length; x++){
            if(this.list[x].email === this.email){
              this.roles = this.list[x].roles
            }else{
             // this.roles = {upstairs: false, factory: true}
            }
        } */
      const user = {
        email: this.email,
        password: this.password
        // roles: this.email
      };
      console.log(user);
      this.$store.dispatch("signInAction", user);
    }
  }
};
</script>

<style></style>
